module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"welcome":"Boas-vindas ao Shop!","header":"O que deseja fazer?","items":{"label":"Criar um pedido","description":"Adicione os itens e gere um pedido manual."}},"en-US":{"welcome":"Welcome to Shop","header":"What would you like to do?","items":{"label":"Create an order","description":"Add the items and make a manual order"}}}')
  delete Component.options._Ctor
}
